import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "status"]
  static values = { 
    url: String, 
    checked: Boolean
  }

  connect() {
    this.updateCheckboxState()
  }

  async toggle() {
    // Prevent multiple clicks during request
    if (this.isUpdating) return
    
    // Get the new state from the checkbox
    const newChecked = this.checkboxTarget.checked
    
    // Disable the checkbox during the request
    this.isUpdating = true
    this.checkboxTarget.disabled = true
    this.showStatus("Updating...", "text-gray-500")

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      
      if (data.success !== false) {
        // Update the checked state based on response
        const serverChecked = data.include_in_digital_garden !== undefined 
          ? data.include_in_digital_garden 
          : newChecked

        this.checkedValue = serverChecked
        this.updateCheckboxState()
        this.showStatus(data.message || "Updated successfully", "text-green-600")
      } else {
        // Revert checkbox state on error
        this.checkboxTarget.checked = this.checkedValue
        this.showStatus(data.message || "Update failed", "text-red-600")
      }
    } catch (error) {
      console.error("Inloop Brain checkbox error:", error)
      // Revert checkbox state on error
      this.checkboxTarget.checked = this.checkedValue
      this.showStatus("An error occurred", "text-red-600")
    } finally {
      this.checkboxTarget.disabled = false
      this.isUpdating = false
    }
  }

  updateCheckboxState() {
    this.checkboxTarget.checked = this.checkedValue
  }

  showStatus(message, className) {
    if (!this.hasStatusTarget) return
    
    this.statusTarget.textContent = message
    this.statusTarget.className = `mt-2 text-sm ${className}`
    
    // Clear the status message after 3 seconds
    if (this.statusTimeout) {
      clearTimeout(this.statusTimeout)
    }
    this.statusTimeout = setTimeout(() => {
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = ""
      }
    }, 3000)
  }
}
